import { sweepstakesReducer } from "@shared/modules/sweepstakes";
import bonuses from "@shared/reducers/bonuses";
import history from "@shared/reducers/history";
import userInterface from "@shared/reducers/interface";
import jackpots from "@shared/reducers/jackpots";
import language from "@shared/reducers/language";
import lobby from "@shared/reducers/lobby";
import user from "@shared/reducers/user";
import { combineReducers } from "redux";
import { reducer as form } from "redux-form";

import games from "./games";

const rootReducer = combineReducers({
  sweepstakesReducer,
  form,
  user,
  lobby,
  games,
  bonuses,
  language,
  jackpots,
  userInterface,
  history,
});

export default rootReducer;
